<template>
  <div class="page">
    <Header theme="white" @setScroll="setScroll" />
    <div class="dbbanner">
      <div>CQM方圆“质量月”</div>
    </div>
    <div class="zly_content">
      <div class="zly_1">
        <div class="title">CQM方圆“质量月”活动信息平台</div>
        <a href="https://www.theportal.cn/app/798b77b0-064e-4455-aa7d-7cc4c610a051" target="_blank">
          <div class="btn">
            <div>点击跳转</div>
            <img class="tiaozhuan" src="../../assets/images/tiaozhuan.png" alt="" srcset="" />
          </div>
        </a>

      </div>
      <div class="zly_2">
        <div class="title">质量专家遴选表单填报地址</div>
        <a href="https://1934dab854d86b03.share.mingdao.net/public/form/0c482bbfd7d642fb80a1118d3baa52d4"
          target="_blank">
          <div class="btn">
            <div>点击跳转</div>
            <img class="tiaozhuan" src="../../assets/images/tiaozhuan.png" alt="" srcset="" />
          </div>
        </a>
      </div>
      <div class="zly_3">
        <div class="title">关于积极参与 2024 年全国“质量月”活动的通知</div>
        <a href="../../static/方圆集团公司市场字〔2024〕3号+关于积极参与2024年全国“质量月”活动的通知.pdf"
          target="_blank">
          <div class="btn1">
            <div>点击下载</div>
            <img class="xiazai" src="../../assets/images/xiazai.png" alt="" srcset="" />
          </div>
        </a>

      </div>
      <div class="zly_4">
        <div class="title">关于开展“质量专家说”系列活动的通知</div>
        <div class="btn1" @click="downloadFile('../../static/市场函〔2024〕6号 关于开展“质量专家说”系列活动的通知.pdf')">
          <div>点击下载</div>
          <img class="xiazai" src="../../assets/images/xiazai.png" alt="" srcset="" />
        </div>
      </div>
    </div>
    <Footer class="footer" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  export default {
    data() {
      return {

      }
    },
    components: {
      Header,
      Footer
    },
    methods: {
      downloadFile(href) {
        window.location.href = href

      }
    }
  }
</script>

<style scoped>
  .page {
    height: 100vh;
    position: relative;
    background: #F9F9F9;
    /* display: flex;
    justify-content: center;
    align-items: center; */
  }

  .zly_content {
    width: 70%;
    margin: 50px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    box-sizing: border-box;
    padding: 40px;
  }

  .zly_content>div {
    margin: 15px;
    box-sizing: border-box;
    padding: 30px 40px;

  }

  .zly_content>div>.title {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #121E30;
  }

  .btn {
    margin-top: 20px;
    width: 140px;
    height: 45px;
    background: #002073;
    border-radius: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .btn1 {
    margin-top: 20px;
    width: 140px;
    height: 45px;
    background: #EA3E3E;
    border-radius: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }


  .btn>div,
  .btn1>div {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 89px;
    margin-right: 5px;
  }

  .tiaozhuan {
    width: 15px;
    height: 6px;
  }

  .xiazai {
    width: 11px;
    height: 16px;
  }

  .zly_1 {
    width: 45%;
    height: 160px;
    background: url(../../assets/images/zly_1.png) top center no-repeat;
    background-size: cover;
  }

  .zly_2 {
    width: 45%;
    height: 160px;
    background: url(../../assets/images/zly_2.png) top center no-repeat;
    background-size: cover;
  }

  .zly_3 {
    width: 45%;
    height: 160px;
    background: url(../../assets/images/zly_3.png) top center no-repeat;
    background-size: cover;
  }

  .zly_4 {
    width: 45%;
    height: 160px;
    background: url(../../assets/images/zly_4.png) top center no-repeat;
    background-size: cover;
  }

  .dbbanner {
    width: 100%;
    height: 300px;
    background: url('../../assets/images/yysc_BJ@2x.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 84px;
    box-sizing: border-box;
    padding-left: 100px;
  }

  .dbbanner>div {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 40px;
    color: #FFFFFF;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/ZLYList.vue